import { Injectable } from '@angular/core';
import { BlobServiceClient, ContainerClient } from '@azure/storage-blob';
import { environment } from 'src/environments/environment';
import { ApiService } from './api/api.service';
import { UserDataService } from './user-data/user-data.service';

@Injectable()
export class AzureBlobStorageService {
  private storageAccount = environment['azureBlobStorageName'];
  private storageContainer: any;
  public sas = "";

  public isSASAvailable = false;

  constructor(
    private _apiService: ApiService,
    private _userDataService: UserDataService
  ) {
  } // CONSTRUCTOR

  public async generateSasToken() {
    const sasObj: any = await this._apiService.get('SASToken/' + sessionStorage.getItem("secretKey")).toPromise();
    this.sas = sasObj.sas;
    this.isSASAvailable = true;
    return sasObj;
  }

  // TO DO: CHECK VALIDITY OF TOKEN. IF NOT VALID THEN GET AGAIN.

  public async uploadFile(content: Blob, name: string, handler: () => void, firstTimeUser?: boolean) {
    if (firstTimeUser) {
      this.storageContainer = this._userDataService.getCompanyID();
      const response: any = await this._apiService.get('SASToken/' + this.storageContainer).toPromise();
      this.sas = response.sas;
      this.isSASAvailable = true;
    }
    this.uploadBlob(content, name, this.containerClient(), handler)
  } // FN

  public async listFiles(): Promise<string[]> {
    await this.generateSasToken();
    return new Promise((resolve, reject) => {
      this._userDataService.setCompanyId().subscribe((res: any) => {
        this.storageContainer = this._userDataService.getCompanyID();
        this.storageContainer = this.storageContainer?.toLowerCase();
        this.listBlobs(this.containerClient()).then((res: any) => {
          resolve(res)
        }).catch(error => {
          reject(error);
        });
      })
    });
  } // FN

  public downloadFile(name: string, handler: (blob: Blob) => void) {
    this.downloadBlob(name, this.containerClient(), handler)
  } // FN

  public deleteFile(name: string, handler: () => void) {
    this.deleteBlob(name, this.containerClient(), handler)
  } // FN

  private uploadBlob(content: Blob, name: string, client: ContainerClient, handler: () => void) {
    let blockBlobClient = client.getBlockBlobClient(name);
    blockBlobClient.uploadData(content, { blobHTTPHeaders: { blobContentType: content.type } })
      .then(() => handler())
  } // FN

  private async listBlobs(client: ContainerClient): Promise<string[]> {
    let result: string[] = []
    let blobs = client.listBlobsFlat();
    for await (const blob of blobs) {
        result.push(blob.name)
    }
    return result;
  } // FN

  private downloadBlob(name: string, client: ContainerClient, handler: (blob: Blob) => void) {
    const blobClient = client.getBlobClient(name);
    blobClient.download().then((resp: any) => {
      resp.blobBody.then((blob: any) => {
        handler(blob)
      })
    })
  } // FN

  private deleteBlob(name: string, client: ContainerClient, handler: () => void) {
    client.deleteBlob(name).then(() => {
      handler()
    })
  } // FN

  private containerClient(): ContainerClient {
    return new BlobServiceClient(`https://${this.storageAccount}.blob.core.windows.net?${this.sas}`)
      .getContainerClient(this.storageContainer);
    // FN
  }

} //EXPORT
